<template>
    <div class="w-full h-32 pt-4" :style="state.backgroundStyle">
        <div class="flex relative">
            <img class="absolute left-4 top-2.5" :src="state.icon" alt=""  @click="clickBack()">
            <img class="w-40 mx-auto " :src="state.logo" alt="">
        </div>
    </div>
</template>
<script>
import { reactive, onUpdated } from "vue";
import ConfigManager from '@/config/ConfigManager';

export default {
    name: 'Topbar',
    props: {
        theme: Object,
        appName: String
    },
    setup: function (props) {
        const state = reactive({
            themeColor: [],
            logo: '',
            icon: '',
            backgroundStyle: {
                backgroundColor : '',
            },
        })

        onUpdated(() => {
            state.themeColor = props.theme
            getImgBlob()
            getBgClass()
        })
        const getBgClass = () => {
            state.backgroundStyle.backgroundColor = state.themeColor.color_1
        }
        const getImgBlob = () => {
            let img = ConfigManager.getBlobUrl()  + `/webconfig/${props.appName}/imgannouncement/`;
            state.logo = img + state.themeColor.img.logo
            state.icon = img + state.themeColor.img.icon
        }

        return {
            state: state,
            getBgClass,
            getImgBlob
        }
    },
    methods: {
        clickBack: function() {
            this.$emit("onClickBack");
        },
    }
}
</script>